// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WNZt","clinicsSelect":"styles_clinicsSelect__1fVkz"};